export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
export const WEDDING_DATE = '2026-11-21T12:00:00+01:00';
export const WEDDING_LOCATION = 'Masia les Casotes, Onda';
export const COUPLE_NAMES = 'Julio & Cristina';
export const CONTACT_EMAIL = 'crisgavijupeca@gmail.com';